import { DurationFactorTypeBase } from './base/duration-factor-type-base';

export class DurationFactorType extends DurationFactorTypeBase { }